// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xhBD","textarea":"styles_textarea__wK1Ox"};